function facetsForm(data = {}) {
  var { removeSectionWrapper } = Alpine.store('utilities');

  return {
    ...data,

    isLoading: false,

    onSubmit() {
      if (this.isLoading) return;

      this.isLoading = true;

      this.$dispatch('facetsformsubmitstart');

      var url = new URL(location);

      url.search = '';

      url += `?${new URLSearchParams(new FormData(this.$root)).toString()}`;

      this.submit(url);
    },

    submit(url) {
      var sectionUrl = new URL(url);

      sectionUrl.searchParams.set('section_id', this.sectionId);

      fetch(sectionUrl)
        .then((res) => {
          if (!res.ok) {
            throw new Error();
          }

          return res.text();
        })
        .then((res) => {
          var sectionHtml = removeSectionWrapper(res);

          this.$dispatch('facetsformsubmitsuccess', { url, sectionHtml });
        })
        .catch((err) => () => {
          this.$dispatch('facetsformsubmiterror');
        })
        .finally(() => {
          this.isLoading = false;
          document.dispatchEvent(new CustomEvent('facetsformsubmitend'));
        });
    },

    onLinkClick() {
      if (this.isLoading) return;

      this.isLoading = true;

      this.$dispatch('facetsformsubmitstart');

      this.submit(this.$el.href);
    }
  };
}; 

document.addEventListener('alpine:init', () => {
  Alpine.data('facetsForm', facetsForm);
});
